// extracted by mini-css-extract-plugin
export default {"ul":"ConfirmPassword_ul__m7R06"};